import type { ImageProps } from 'next/image';

import { getImageServer } from '@/utils/getImageServer';
import { getUrl } from '@/utils/getUrl';
import { isEmpty, isString, isUndefined } from 'typesafe-utils';

export const getImageUrl = (src?: ImageProps['src']): URL | null => {
  if (isUndefined(src) || !isString(src) || isEmpty(src) || src === '/') {
    return null;
  }

  return getUrl(src, getImageServer());
};
